/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popSysConfig.vue?vue&type=template&id=3658528e&scoped=true"
import script from "./popSysConfig.vue?vue&type=script&lang=js"
export * from "./popSysConfig.vue?vue&type=script&lang=js"
import style0 from "./popSysConfig.vue?vue&type=style&index=0&id=3658528e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3658528e",
  null
  
)

export default component.exports